import ManagerActions from '../actions/ManagerActions'

function initialState() {
  return {
    err: null,
    loader: 0,
  }
}

export default function manager(state = initialState(), action) {
  const newState = state
  switch (action.type) {
    case ManagerActions.UPDATE_ERROR:
      return { ...state, err: action.payload }

    case ManagerActions.INCREMENT_LOADER:
      return { ...state, loader: state.loader + 1 }

    case ManagerActions.DECREMENT_LOADER:
      return { ...state, loader: state.loader - 1 }

    case ManagerActions.RESET_LOADER:
      newState.loader = 0
      return { ...state, loader: newState.loader }
    default:
      return state
  }
}
